import { Box } from '@mui/material';
import { Logo } from '@src/components/logo';
import { useAppContext } from '@src/contexts';
import { useTheme } from '@src/themes';
import { FC } from 'react';

const Header: FC = () => {
  const { COLORS } = useTheme();
  const { isMobile } = useAppContext();

  return (
    <Box
      sx={{
        background: COLORS.primary.main,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingY: isMobile ? 1 : 2,
        borderRadius: '0 0 8px 8px',
      }}
    >
      <Logo width={isMobile ? 50 : 130} />
    </Box>
  );
};

export { Header };
